import styled, { css } from 'styled-components';
import CardBlock, { CardBlockProps } from './card-block';

interface Props extends CardBlockProps {
	showGuttersBetween: boolean;
}

/**
 * `CardHorizontalBlock` is a block used for layouting its children horizontally.
 *
 * The children has a background. The last of the children, will take up the remaining space.
 */
const CardHorizontalBlock = styled(CardBlock)<Props>`
	padding: 0;
	background: transparent;
	flex: 0;

	${({ showGuttersBetween }) =>
		showGuttersBetween &&
		css`
			& > * {
				margin-right: 2px;
				padding: 8px;
				flex: 0 0 auto;

				&:last-child {
					margin-right: 0;
					flex: 1;
				}
			}
		`}
`;

CardHorizontalBlock.defaultProps = {
	flex: '1'
};

export default CardHorizontalBlock;
